import React from 'react';
import {DropdownMenu,} from 'reactstrap';
import {config} from '../../../../../helpers/config';
import classnames from '../../../../../helpers/classnames';
import {LanguageSwitcherProps} from '../../../../../@types/components/LanguageSwitcher';
import {connect, ConnectedProps} from 'react-redux';
import {IReduxStoreState} from '../../../../../@interfaces';
import {setLocale} from '../../../../../_redux/locale/actions';
import trans from '../../../../../helpers/trans';
import {IConfigEntries} from '../../../../../@interfaces/services/Config/IConfigEntries';
import ControlledPopupable from '../../../../Popupable/ControlledPopupable';

type Props = ConnectedProps<typeof connector> & Record<string, unknown> & LanguageSwitcherProps;

type LanguagesKeys = keyof IConfigEntries['languages'];

export class LanguageSwitcher extends ControlledPopupable<Props> {
    protected onDropdownItemClick(e: React.SyntheticEvent, item: LanguagesKeys) {
        this.props.setLocale(item);
    }

    protected getDropdownToggleProps() {
        return {
            className: classnames('btn language-switcher__toggle', this.props.toggleDropdownButtonClassName),
            tag: 'button',
            type: 'button',
        };
    }

    protected renderDropdownToggleContent() {
        const langDetails = this.getPublicLanguageDetails();

        return <img src={langDetails.icon}
                    alt={trans(langDetails.title)}
                    height="16"
                    className="me-1"/>;
    }

    protected getDropdownItems() {
        return this.getAvailableLocales();
    }

    protected getDropdownItemProps(item: LanguagesKeys) {
        return {
            className: classnames('language-switcher__item', 'notify-item', {
                'language-switcher__item--active': this.props.locale === item,
            })
        };
    }

    protected renderDropdownItemContent(locale: LanguagesKeys) {
        const langDetails = this.getPublicLanguageDetails(locale);
        const label = trans(langDetails.title, undefined, langDetails.title, locale);

        return <>
            <img src={langDetails.icon} alt={label} className="me-2" height="12"/>
            <span className="align-middle">{label}</span>
        </>;
    }

    protected renderDropdownMenu() {
        return <DropdownMenu className="language-switcher__menu dropdown-menu-end">
            {this.getAvailableLocales().map(this.renderDropdownItem)}
        </DropdownMenu>;
    }

    protected getAvailableLocales(): LanguagesKeys[] {
        return config('client.available-languages') ?? [];
    }

    protected getPublicLanguageDetails(language?: LanguagesKeys): IConfigEntries['languages'][LanguagesKeys] {
        return config(`languages.${language ?? this.props.locale}` as any);
    }
}

export const connector = connect(
        (state: IReduxStoreState) => state.locale,
        {setLocale}
);

export default connector(LanguageSwitcher);
